var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#snfl1d4owa)",
    strokeWidth: 1.333,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.167.667H7a.97.97 0 0 0-.707.312c-.188.2-.293.472-.293.755v3.6M11.167.667l3.5 3.733m-3.5-3.733V4.4h3.5m0 0v6.534c0 .283-.106.554-.293.754a.97.97 0 0 1-.707.312h-5",
    stroke: "#545454",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.417 4H2.333a.97.97 0 0 0-.707.312c-.187.2-.293.472-.293.755v9.2c0 .283.106.554.293.754a.97.97 0 0 0 .707.312H9a.97.97 0 0 0 .707-.312c.188-.2.293-.471.293-.754v-1.934",
    stroke: "#545454",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.667 11 10 6.667m0 0H7.667m2.333 0V9",
    stroke: "#545454"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "snfl1d4owa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.efa95c50c638e092cc57baad2507a183.svg";
export { ForwardRef as ReactComponent };